import { create } from 'zustand';

/**
 * Which mail snapshot the single <MailPreviewDialog /> is showing. Any chip
 * anywhere in the app opens it by id; the dialog itself owns the fetch, so a
 * link never has to hold a snapshot payload.
 */
interface MailPreviewState {
  open: boolean;
  messageId: string | null;
  /** The journey the link came from — scopes thread expansion to its vendor. */
  journeyId: string | null;
  /** What the chip called it ("invoice", "announcement") — shown while loading. */
  label: string | null;
  openPreview: (messageId: string, options?: { journeyId?: string | null; label?: string | null }) => void;
  closePreview: () => void;
}

export const useMailPreviewStore = create<MailPreviewState>()((set) => ({
  open: false,
  messageId: null,
  journeyId: null,
  label: null,
  openPreview: (messageId, options = {}) =>
    set({
      open: true,
      messageId,
      journeyId: options.journeyId ?? null,
      label: options.label ?? null,
    }),
  closePreview: () => set({ open: false, messageId: null, journeyId: null, label: null }),
}));
